import { API_URL } from "../utility/constants";


export async function getSurveyQuestion(token, customer_id) {
    try {
        const response = await fetch(API_URL + "superAdmin/superAdminSurvey/getSurveyQuestion?customer_id=" + customer_id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function getSurveyQuestionWithId(token, type, id, customer_id) {
    try {
        const response = await fetch(API_URL + "superAdmin/superAdminSurvey/getSurveyQuestion?" + type + "=" + id + "&customer_id=" + customer_id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function getActiveSurveyQuestionWithId(token, type, id, customer_id) {
    try {
        const response = await fetch(API_URL + "superAdmin/superAdminSurvey/getActiveSurveyQuestion?" + type + "=" + id + "&customer_id=" + customer_id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function getSurveyAnswers(token, survey_id, customer_id) {
    try {
        const response = await fetch(API_URL + "superAdmin/superAdminSurvey/getSurveyAnswers?survey_id=" + survey_id + "&customer_id=" + customer_id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function addSurveyQuestion(token, data) {
    try {
        const response = await fetch(API_URL + `superAdmin/superAdminSurvey/addSurveyQuestion`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function updateSurveyQuestion(token, data) {
    try {
        const response = await fetch(API_URL + `superAdmin/superAdminSurvey/updateSurveyQuestion`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function deleteSurveyQuestion(token, survey_id) {
    try {
        const response = await fetch(API_URL + "superAdmin/superAdminSurvey/deleteSurveyQuestion?id=" + survey_id, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};